const CLICK_VOLUME_ML = 0.01;

function formatNumber(n, decimals = 2) {
  if (Number.isInteger(n)) return n.toString();
  return parseFloat(n.toFixed(decimals)).toString();
}

function showError(msg) {
  const el = document.getElementById('calc-error');
  if (!el) return;
  el.textContent = msg;
  el.removeAttribute('hidden');
  document.getElementById('calc-results')?.setAttribute('hidden', '');
}

function clearError() {
  const el = document.getElementById('calc-error');
  if (el) el.setAttribute('hidden', '');
}

function calculate() {
  clearError();

  const totalMg = parseFloat(document.getElementById('calc-total-mg')?.value);
  const totalMl = parseFloat(document.getElementById('calc-total-ml')?.value);
  const doseMg  = parseFloat(document.getElementById('calc-dose-mg')?.value);

  if (isNaN(totalMg) || isNaN(totalMl) || isNaN(doseMg)) {
    showError('Please fill in all three fields before calculating.');
    return;
  }
  if (totalMg <= 0 || totalMl <= 0 || doseMg <= 0) {
    showError('All values must be greater than zero.');
    return;
  }
  if (doseMg > totalMg) {
    showError('Your desired dose cannot be greater than the total peptide amount.');
    return;
  }

  const concentration  = totalMg / totalMl;
  const dosesCount     = totalMg / doseMg;
  const volumePerDose  = doseMg / concentration;
  const clicksPerDose  = volumePerDose / CLICK_VOLUME_ML;

  document.getElementById('calc-out-concentration').textContent = formatNumber(concentration, 2);
  document.getElementById('calc-out-doses').textContent         = formatNumber(dosesCount, 1);
  document.getElementById('calc-out-volume').textContent        = formatNumber(volumePerDose, 3);
  document.getElementById('calc-out-clicks').textContent        = Math.round(clicksPerDose).toString();

  const explanation = document.getElementById('calc-explanation');
  if (explanation) {
    explanation.textContent =
      `${totalMg} mg peptide in ${totalMl} ml water = ${formatNumber(concentration, 2)} mg/ml concentration. ` +
      `Each ${doseMg} mg dose requires ${formatNumber(volumePerDose, 3)} ml (${Math.round(clicksPerDose)} clicks). ` +
      `You have ${formatNumber(dosesCount, 1)} total doses available.`;
  }

  document.getElementById('calc-results')?.removeAttribute('hidden');
  document.getElementById('calc-results')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function init() {
  document.getElementById('calc-submit')?.addEventListener('click', calculate);

  ['calc-total-mg', 'calc-total-ml', 'calc-dose-mg'].forEach((id) => {
    document.getElementById(id)?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') calculate();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
